export enum ListDataFiltersTypeEnum {
  SELECT = "select",
  DATE = "date",
  DATE_RANGE = "dateRange",
  CHECKBOX = "checkbox",
  TEXT = "text",
  ARRAY_TEXT = "arrayText",
  MASK_TEXT = "maskText",
  CURRENT_ITEMS_ONLY = "currentItemsOnly",
  SERIAL_NUMBER = "serialNumber",
  NUMBER = "number"
}

export enum ListDataMassActionsTypes {
  INVENTORY = "INVENTORY",
  OFFER = "OFFER",
  LINE = "LINE"
}

export enum ListDataMassActionsErrorMessages {
  SELECT_ITEM_EMPTY = `Selecione no mínimo um item da lista para atualizar os valores.`,
  FIELD_VALUE_EMPTY = `Selecione no mínimo um CAMPO para atualizar o valor.`,
  GENERIC_ERROR = `Erro ao atualizar itens, contate o suporte`
}
export enum ListDataMassActionsSuccessMessages {
  UPDATE_SUCCESS = "Itens Atualizados com sucesso",
  OFFER_UPDATE_GENERIC_SUCCESS = "Pacotes de Benefícios atualizadas com sucesso"
}
